import React, { useEffect } from 'react';

import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

import calendarIcon from 'assets/images/properties/calendar-event.svg';
import { ReturnComponentType } from 'common';
import { DateFormat, Pagination, Paths } from 'enums';
import { useAppSelector, useScrollPagination, useTypedDispatch } from 'hooks';
import {
  fetchInspections,
  selectInspections,
  selectInspectionsPagination,
  selectUserRole,
} from 'state';
import './PropertyHistorySection.scss';
import { setInspections, setInspectionsPagination } from 'state/actions';
import { checkIsInspector } from 'utils';

type PropertyHistorySectionType = {
  propertyId: string;
};
export const PropertyHistorySection = ({
  propertyId,
}: PropertyHistorySectionType): ReturnComponentType => {
  const navigate = useNavigate();
  const dispatch = useTypedDispatch();
  const inspections = useAppSelector(selectInspections);
  const userRole = useAppSelector(selectUserRole);
  const { page, count } = useAppSelector(selectInspectionsPagination);

  const scrollHandler = useScrollPagination({
    count,
    page,
    dataArrayLength: inspections?.length,
    actionCreator: setInspectionsPagination,
  });

  const onInspectionClick = (inspectionId: string) => {
    if (!checkIsInspector(userRole)) navigate(`${Paths.INSPECTIONS}/${inspectionId}`);
  };

  useEffect(() => {
    if (page > 1) {
      dispatch(fetchInspections(true, propertyId));
    }
  }, [dispatch, page]);

  useEffect(() => {
    dispatch(fetchInspections(false, propertyId));

    return () => {
      dispatch(setInspectionsPagination({ page: Pagination.START_PAGE }));
      dispatch(setInspections([]));
    };
  }, [dispatch]);

  return (
    <section className="PropertyHistorySection">
      <h4>History</h4>
      <div onScrollCapture={scrollHandler} className="PropertyHistorySection_Table">
        {inspections?.map(inspection => {
          return (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            <div
              key={inspection?.id}
              className="PropertyHistorySection_Table_Row"
              onClick={() => onInspectionClick(inspection?.id)}
              style={{ cursor: checkIsInspector(userRole) ? 'default' : 'pointer' }}
            >
              <div>
                <div className="PropertyHistorySection_Table_Row_Dot" />
                {inspection?.name ?? '-'}
              </div>
              <div>
                <img src={calendarIcon} alt="calendar-icon" />
                <span>
                  {inspection?.createdAt
                    ? dayjs(inspection?.createdAt).format(DateFormat.GENERAL)
                    : '-'}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};
